import { MainContentControlCenter } from "./MainContent.controlcenter";
import { useCurrentProductVariant } from "./hooks/useCurrentProductVariant";

export const MainContent: React.FC = () => {
  const productVariant = useCurrentProductVariant();
  console.log(productVariant);
 
  return <MainContentControlCenter />
  ;
};
